import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import Sidebar from 'blocks.app/sidebar/sidebar'
import ToolbarFile from '../__toolbarFile/files__toolbarFile'
import ToolbarUploads from '../__toolbarUploads/files__toolbarUploads'
import FilesEditTagsModal from '../__editTagsModal/files__editTagsModal'
import TagsList from 'blocks.app/tagsList/tagsList'
import translate from 'core/translate'
import helpers from 'core/helpers'
import { routes } from 'features/routes'
import { api } from 'core/api/ConnectionManager'
// @ts-ignore
import omitEmpty from 'omit-empty'
import filesStyles from '../files.jcss'
import { grid, item, text } from '../../../theme'
import { getURLSearchParamsByLocation, getURLSearchParamsString } from 'features/routes/utils'
import { withRouter } from 'react-router'
import { changeLocation } from 'features/routes'
import { filesActions, rotateVideo } from '../files.state'
import { cancelUpload, cancelUploadByUrl } from 'core/services/DownloadService/DownloadService.state'
import { SmartFolderSettings } from '../__smartFolder/files__smartFolderModal'
import Modal from 'blocks.simple/modal/modal'
import { cn } from 'ethcss'
import { Typography } from 'atoms/Typography'
import { Button } from 'molecules/Button'
import Icon from 'blocks.simple/icon/icon'
import moment from 'moment'
import fileSize from 'filesize'
import FilesModeration from '../__moderation/files__moderation'
import ModalWithBackground from 'blocks.simple/modalWithBackground/modalWithBackground'
import FilesModerationStatus from '../__moderation/status/files__moderationStatus'
import { SidebarMultiselectMenu } from '../../../blocks.app/sidebarMultiselectMenu/SidebarMultiselectMenu'
import { MenuItem } from '../../displays/__toolbarContent/displays__toolbarContent'

interface IBottomContent {
    folderId?: string
    id?: number
    query?: any
    selectedInfo?: any
    openTagsEditModalOpen: () => void
    onChange?: ([]) => void
    landscapeStatus?: string
    downloadLink: string
    rotateVideo?: (sourceId: { sourceId: number }) => void
    openSmartFolderSettings?: () => void
    onEdit: () => void
    showPreview: boolean
    onClickPreview?: () => void
    selectedItems?: {}[]
    onCloseSmartFolderSettings?: () => void
    contentModeration?: boolean
    setOpenModeration: React.Dispatch<React.SetStateAction<boolean>>
    setOpenModerationStatus: React.Dispatch<React.SetStateAction<boolean>>
}

const getMediaFiles = (type: string) => {
    return type === 'video' || type === 'audio'
}
const getDownloadFiles = (type: string) => {
    const types = ['rss', 'web_page', 'text', 'table', 'link', 'xml', 'csv', 'stream']

    return !types.includes(type)
}
const checkTextItems = (arr: {}[]) => {
    return arr.every((item: any) => item.type === 'text' || item.type === 'stream' || item.type === 'link')
}
const getContentOrientation = (string: string) => {
    if (Number(string.split('x').shift()) > Number(string.split('x').pop())) {
        return translate('orientationH').toLowerCase()
    } else {
        return translate('orientationV').toLowerCase()
    }
}
const BottomContent = (p_: IBottomContent) => {
    const [isOpenedProperties, setOpenedProperties] = useState<boolean>(false)
    const [isOpenedWhereUse, setOpenedWhereUse] = useState<boolean>(false)
    const [usageStats, setUsageStats] = useState({
        broadcasts: 0,
        digitalSignage: 0,
        playlist: 0,
        references: 0,
    })
    const [contentProperties, setContentProperties] = useState<any>()
    const isShowVideoEditorMenuItem =
        p_.selectedInfo &&
        p_.selectedInfo.fileType === 'video' &&
        helpers.isAvailableAction(p_.selectedInfo, {
            key: 'files',
            action: 'update',
        })
    const queryParameters: any = helpers.getQuery(p_.query, 'files')

    if (!queryParameters.folderId) {
        queryParameters.folderId = null
    } else {
        queryParameters.folderId = parseInt(queryParameters.folderId, 10)
    }

    const usageStatsRows = [
        {
            key: 'broadcasts' as const,
            label: translate('broadcasts'),
            path: routes.broadcasts.path,
        },
        {
            key: 'digitalSignage' as const,
            label: translate('devices'),
        },
        {
            key: 'playlist' as const,
            label: translate('playlist'),
        },
        {
            key: 'references' as const,
            label: translate('references'),
        },
    ].filter((row) => usageStats[row.key] > 0)

    useEffect(() => {
        if (
            helpers.isAvailable({ key: 'broadcast', action: 'read', strict: true }) &&
            (isOpenedWhereUse || isOpenedProperties)
        ) {
            api.send('getBroadcastStats', { sourceId: p_.selectedInfo.id }).then((data: any) => {
                setUsageStats({
                    broadcasts: data.broadcasts ?? 0,
                    digitalSignage: data.digitalSignage ?? 0,
                    playlist: data.playlist ?? 0,
                    references: data.references ?? 0,
                })
            })
        }
    }, [isOpenedWhereUse, isOpenedProperties])

    useEffect(() => {
        isOpenedProperties &&
            api.send('getContentProperties', { sourceId: p_.selectedInfo.id }).then((data: any) => {
                setContentProperties(data)
            })
    }, [isOpenedProperties])

    return (
        <div>
            {!p_.selectedInfo && (
                <div
                    className={filesStyles.menuItem}
                    onClick={function () {
                        if (p_.openTagsEditModalOpen) {
                            p_.openTagsEditModalOpen()
                        }
                    }}
                >
                    {translate('tags')}
                </div>
            )}
            {p_.selectedInfo && queryParameters.query && queryParameters.folderId !== p_.selectedInfo.folderId && (
                <div
                    className={filesStyles.menuItem}
                    onClick={function () {
                        changeLocation({
                            pathname: `/${routes.files.path}`,
                            search: getURLSearchParamsString({
                                folderId: p_.selectedInfo && p_.selectedInfo.folderId,
                            }),
                        })
                    }}
                >
                    {translate('location')}
                </div>
            )}
            {p_.landscapeStatus === 'error' && (
                <div
                    className={filesStyles.menuItem}
                    onClick={function () {
                        if (p_.rotateVideo && p_.id) {
                            p_.rotateVideo({ sourceId: p_.id })
                        }
                    }}
                >
                    {translate('rotateAgain')}
                </div>
            )}
            {p_.selectedInfo && p_.contentModeration && helpers.isAvailable({ key: 'moderation', action: 'update' }) && (
                <div className={filesStyles.menuItem} onClick={() => p_.setOpenModeration(true)}>
                    {translate('moderation')}
                </div>
            )}
            {p_.selectedInfo && p_.contentModeration && helpers.isAvailable({ key: 'moderation', action: 'read' }) && (
                <div className={filesStyles.menuItem} onClick={() => p_.setOpenModerationStatus(true)}>
                    {translate('moderationStatus')}
                </div>
            )}
            {p_.downloadLink && (
                <a
                    className={filesStyles.menuItem}
                    href={p_.downloadLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={function () {
                        if (p_.onChange) {
                            p_.onChange([])
                        }
                    }}
                >
                    {translate('download')}
                </a>
            )}
            {p_.selectedInfo &&
                !p_.selectedInfo.isDirectory &&
                (p_.selectedInfo.fileType === 'video' ||
                    p_.selectedInfo.fileType === 'image' ||
                    p_.selectedInfo.fileType === 'audio' ||
                    p_.selectedInfo.fileType === 'web_app' ||
                    p_.selectedInfo.fileType === 'stream' ||
                    p_.selectedInfo.fileType === 'web_page') && (
                    <div className={filesStyles.menuItem} onClick={() => setOpenedProperties(!isOpenedProperties)}>
                        {translate('properties')}
                    </div>
                )}
            {p_.selectedInfo ? (
                p_.selectedInfo.isDirectory ? (
                    <div className={filesStyles.menuItem} onClick={p_.openSmartFolderSettings}>
                        {translate('rules')}
                    </div>
                ) : null
            ) : null}
            {p_.selectedInfo &&
                p_.selectedInfo.data &&
                p_.selectedInfo.data.widgetInfo &&
                p_.selectedInfo.data.widgetInfo.isEditable && (
                    <div className={filesStyles.menuItem} onClick={p_.onEdit}>
                        {translate('edit')}
                    </div>
                )}
            {p_.showPreview && (
                <div
                    className={filesStyles.menuItem}
                    onClick={function () {
                        if (p_.onClickPreview) {
                            p_.onClickPreview()
                        }
                    }}
                >
                    {translate('preview')}
                </div>
            )}
            {isShowVideoEditorMenuItem && (
                <div
                    className={filesStyles.menuItem}
                    onClick={function () {
                        changeLocation({
                            pathname: `/${routes.videoEditor.path}`,
                            search: getURLSearchParamsString({
                                sourceId: p_.selectedInfo.id,
                            }),
                        })
                    }}
                >
                    {translate('videoEditor')}
                </div>
            )}
            {p_.selectedInfo && !p_.selectedInfo.isDirectory && (
                <div className={filesStyles.menuItem} onClick={() => setOpenedWhereUse(!isOpenedWhereUse)}>
                    {translate('whereUsed')}
                </div>
            )}
            {!p_.selectedInfo && (
                <div
                    className={filesStyles.menuItem}
                    onClick={function () {
                        if (p_.onChange) {
                            p_.onChange([])
                        }
                    }}
                >
                    {translate('deselect')}
                </div>
            )}

            {isOpenedWhereUse && (
                <Modal
                    open={isOpenedWhereUse}
                    showCloseIcon={false}
                    mod="clear"
                    onClose={() => setOpenedWhereUse(false)}
                >
                    <div className={cn(grid.full, grid.rowCenter, item.blackOpacity)}>
                        <div className={cn(item.whereUseCard, item.shadowModal, item.rounded_full_mini)}>
                            <div className={cn(grid.col, grid.mb_md)}>
                                {usageStatsRows.length > 0 ? (
                                    <>
                                        <div className={cn(grid.row)}>
                                            <Typography className={cn(grid.mb_md, text.bold)}>
                                                {translate('contentUsedIn')}:
                                            </Typography>
                                        </div>

                                        {usageStatsRows.map((row) => (
                                            <div key={row.key} className={cn(grid.row, grid.justify, grid.mt_mini)}>
                                                <Typography type="text">
                                                    {row.label}: <b>{usageStats[row.key]}</b>
                                                </Typography>
                                                {'path' in row && row.path && (
                                                    <span
                                                        className={cn(text.underline, item.pointer)}
                                                        onClick={function () {
                                                            changeLocation({
                                                                pathname: `/${row.path}`,
                                                                search: getURLSearchParamsString({
                                                                    contentId: p_.selectedInfo.id,
                                                                }),
                                                            })
                                                        }}
                                                    >
                                                        {translate('go')}
                                                    </span>
                                                )}
                                            </div>
                                        ))}
                                    </>
                                ) : (
                                    <Typography type="text">{translate('contentNotUsedAnywhere')}</Typography>
                                )}
                            </div>

                            <Button className={cn(grid.mt_md, item.rel)} onClick={() => setOpenedWhereUse(false)}>
                                {translate('cancel')}
                            </Button>
                        </div>
                    </div>
                </Modal>
            )}

            {isOpenedProperties && contentProperties && (
                <Modal
                    open={isOpenedProperties}
                    showCloseIcon={false}
                    mod="clear"
                    onClose={() => {
                        setOpenedProperties(false)
                        setContentProperties(null)
                    }}
                >
                    <div className={cn(grid.full, grid.rowCenter, item.blackOpacity)}>
                        <div className={filesStyles.contentPropertiesModal}>
                            <div className={filesStyles.contentPropertiesHeader}>
                                <Typography type="title" className={filesStyles.contentPropertiesTitle}>
                                    {translate('properties')} {translate('content').toLowerCase()}
                                </Typography>
                                <Icon
                                    type="close_tiny"
                                    size={20}
                                    className={filesStyles.contentPropertiesClose}
                                    onClick={() => {
                                        setOpenedProperties(false)
                                        setContentProperties(null)
                                    }}
                                />
                            </div>
                            <div className={filesStyles.contentPropertiesBody}>
                                <div className={filesStyles.contentPropertiesSectionTitle}>{translate('basics')}</div>
                                <div className={filesStyles.contentPropertiesGrid}>
                                    <div className={filesStyles.contentPropertiesRow}>
                                        <span>{translate('name')}:</span>
                                        <span>{contentProperties.name || '-'}</span>
                                    </div>
                                    <div className={filesStyles.contentPropertiesRow}>
                                        <span>{translate('type')}:</span>
                                        <span>
                                            {p_.selectedInfo.fileType === 'stream'
                                                ? translate('mediaStream')
                                                : translate(contentProperties.type)}
                                        </span>
                                    </div>
                                    {contentProperties.size && (
                                        <div className={filesStyles.contentPropertiesRow}>
                                            <span>{translate('size')}:</span>
                                            <span>{fileSize(contentProperties.size)}</span>
                                        </div>
                                    )}
                                    <div className={filesStyles.contentPropertiesRow}>
                                        <span>{translate('createdAt')}:</span>
                                        <span>{moment(contentProperties.createdAt).format('DD.MM.YYYY HH:mm:ss')}</span>
                                    </div>
                                    <div className={filesStyles.contentPropertiesRow}>
                                        <span>{translate('id')}:</span>
                                        <span>{contentProperties.id}</span>
                                    </div>
                                </div>

                                {(contentProperties.resolution ||
                                    contentProperties.codec ||
                                    contentProperties.duration ||
                                    contentProperties.bitrate ||
                                    contentProperties.fps ||
                                    contentProperties.format === 'hls' ||
                                    contentProperties.url) && (
                                    <>
                                        <div className={filesStyles.contentPropertiesSectionTitle}>
                                            {translate('format')}
                                        </div>
                                        <div className={filesStyles.contentPropertiesGrid}>
                                            {contentProperties.resolution && (
                                                <div className={filesStyles.contentPropertiesRow}>
                                                    <span>{translate('resolution')}:</span>
                                                    <span>{contentProperties.resolution}</span>
                                                </div>
                                            )}
                                            {contentProperties.resolution && (
                                                <div className={filesStyles.contentPropertiesRow}>
                                                    <span>{translate('orientation')}:</span>
                                                    <span>{getContentOrientation(contentProperties.resolution)}</span>
                                                </div>
                                            )}
                                            {contentProperties.codec && p_.selectedInfo.fileType === 'video' && (
                                                <div className={filesStyles.contentPropertiesRow}>
                                                    <span>{translate('codecs')}:</span>
                                                    <span>{contentProperties.codec}</span>
                                                </div>
                                            )}
                                            {contentProperties.duration && (
                                                <div className={filesStyles.contentPropertiesRow}>
                                                    <span>{translate('duration')}:</span>
                                                    <span>{helpers.dateForm(contentProperties.duration)}</span>
                                                </div>
                                            )}
                                            {contentProperties.bitrate && (
                                                <div className={filesStyles.contentPropertiesRow}>
                                                    <span>{translate('customBitRate')}:</span>
                                                    <span>{Math.round(contentProperties.bitrate * 0.001)}</span>
                                                </div>
                                            )}
                                            {contentProperties.fps && (
                                                <div className={filesStyles.contentPropertiesRow}>
                                                    <span>{translate('fpsLabel')}:</span>
                                                    <span>{contentProperties.fps}</span>
                                                </div>
                                            )}
                                            {contentProperties.format === 'hls' && (
                                                <>
                                                    <div className={filesStyles.contentPropertiesRow}>
                                                        <span>{translate('videoCodec')}:</span>
                                                        <span>{contentProperties.videoCodec}</span>
                                                    </div>
                                                    <div className={filesStyles.contentPropertiesRow}>
                                                        <span>{translate('audioCodec')}:</span>
                                                        <span>{contentProperties.audioCodec}</span>
                                                    </div>
                                                    <div className={filesStyles.contentPropertiesRow}>
                                                        <span>{translate('videoBitrate')}:</span>
                                                        <span>
                                                            {Math.round(contentProperties.videoBitrate * 0.001)}
                                                        </span>
                                                    </div>
                                                    <div className={filesStyles.contentPropertiesRow}>
                                                        <span>{translate('audioBitrate')}:</span>
                                                        <span>
                                                            {Math.round(contentProperties.audioBitrate * 0.001)}
                                                        </span>
                                                    </div>
                                                </>
                                            )}
                                            {(p_.selectedInfo.fileType === 'web_page' ||
                                                p_.selectedInfo.fileType === 'stream') &&
                                                contentProperties.url && (
                                                    <div className={filesStyles.contentPropertiesRow}>
                                                        <span>{translate('url')}:</span>
                                                        <span>{contentProperties.url}</span>
                                                    </div>
                                                )}
                                        </div>
                                    </>
                                )}

                                {helpers.isAvailable({ key: 'broadcast', action: 'read', strict: true }) &&
                                    usageStatsRows.length > 0 && (
                                        <>
                                            <div className={filesStyles.contentPropertiesSectionTitle}>
                                                {translate('whereUsed')}
                                            </div>
                                            <div className={filesStyles.contentPropertiesGrid}>
                                                {usageStatsRows.map((row) => (
                                                    <div key={row.key} className={filesStyles.contentPropertiesRow}>
                                                        <span>
                                                            {row.label}:{' '}
                                                            <b className={'test-used-in-broad'}>
                                                                {usageStats[row.key]}
                                                            </b>
                                                        </span>
                                                        {'path' in row && row.path ? (
                                                            <span
                                                                className={filesStyles.contentPropertiesAction}
                                                                onClick={function () {
                                                                    changeLocation({
                                                                        pathname: `/${row.path}`,
                                                                        search: getURLSearchParamsString({
                                                                            contentId: p_.selectedInfo.id,
                                                                        }),
                                                                    })
                                                                }}
                                                            >
                                                                {translate('go')}
                                                            </span>
                                                        ) : (
                                                            <span />
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </>
                                    )}

                                {contentProperties.description && (
                                    <div className={'test-comment'}>
                                        <div className={filesStyles.contentPropertiesSectionTitle}>
                                            {translate('comment')}:
                                        </div>
                                        <Typography type="title" className={filesStyles.contentPropertiesCommentText}>
                                            {contentProperties.description}
                                        </Typography>
                                    </div>
                                )}
                            </div>
                            <div className={filesStyles.contentPropertiesFooter}>
                                <Button
                                    mod="default"
                                    className={filesStyles.contentPropertiesCloseButton}
                                    onClick={() => {
                                        setOpenedProperties(false)
                                        setContentProperties(null)
                                    }}
                                >
                                    {translate('close')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </Modal>
            )}
        </div>
    )
}

type Data = { sourceId: number; folderId: number; newFolderId: number }

const FilesToolbar = (p_: any) => {
    const [currentIndexSlider, setCurrentIndexSlider] = useState<number>(0)
    const [sliderItems, setSliderItems] = useState<{}[]>([])
    const [isOpenedSmartFolderSettings, setIsOpenedSmartFolderSettings] = useState<boolean>(false)
    const moveItemRef = useRef<any>(null)
    const deleteItemRef = useRef<any>(null)
    const [isOpenModeration, setOpenModeration] = useState(false)
    const [isOpenModerationStatus, setOpenModerationStatus] = useState(false)

    const openSmartFolderSettings = () => {
        setIsOpenedSmartFolderSettings(true)
    }

    const onCloseSmartFolderSettings = () => {
        setIsOpenedSmartFolderSettings(false)
    }

    const getFilesInFolder = async () => {
        const { selectedInfo, settings, openPreview, ...props } = p_
        let sliderItems = props.files

        // if (settings.view.files === 'list') {
        try {
            const result: any = await api.send('getFilesAndFolders', { folderId: selectedInfo.folderId })
            sliderItems = result.data
                .filter((file: { isDirectory: boolean }) => !file.isDirectory)
                .map((file: any) => {
                    if (file.id !== selectedInfo.id) {
                        return file
                    }

                    return {
                        ...file,
                        style: selectedInfo.style || file.style,
                        data: selectedInfo.data || file.data,
                        settings: selectedInfo.settings || file.settings,
                        textOrientation: selectedInfo.textOrientation || file.textOrientation,
                    }
                })
        } catch (e) {
            console.error(e)
        }
        // }

        const currentIndexSlider = sliderItems.findIndex((item: { id: number }) => item.id === selectedInfo.id)

        setCurrentIndexSlider(currentIndexSlider)
        setSliderItems(sliderItems)
        setTimeout(() => {
            openPreview()
        }, 100)
    }

    const updateSourceTag = (data: {}) => {
        api.send('updateSourceTag', data)
    }

    const deleteSourceTag = (data: {}) => {
        api.send('deleteSourceTag', data)
    }

    const createSourceTag = (data: {}) => {
        api.send('createSourceTag', data)
    }

    const getCustomRightContent = () => {
        const s_ = { currentIndexSlider, sliderItems, isOpenedSmartFolderSettings }
        const query = getURLSearchParamsByLocation(p_.location)
        const folderId: any = query.folderId

        if (p_.selectedInfo) {
            return (
                <ToolbarFile
                    {...p_}
                    previewSliderOptions={{ ...s_ }}
                    onClickPreview={getFilesInFolder}
                    bottomContent={
                        <BottomContent
                            openTagsEditModalOpen={p_.openTagsEditModalOpen}
                            query={query}
                            folderId={folderId}
                            downloadLink={
                                getDownloadFiles(p_.selectedInfo.fileType || p_.selectedInfo.type)
                                    ? p_.downloadLink
                                    : null
                            }
                            showPreview={p_.selectedInfo && getMediaFiles(p_.selectedInfo.fileType)}
                            landscapeStatus={p_.selectedInfo.dataLandscapeStatus}
                            id={p_.selectedInfo.id}
                            selectedInfo={p_.selectedInfo}
                            selectedItems={p_.selectedItems}
                            onClickPreview={getFilesInFolder}
                            onEdit={p_.onEdit}
                            openSmartFolderSettings={openSmartFolderSettings}
                            onCloseSmartFolderSettings={onCloseSmartFolderSettings}
                            setOpenModeration={setOpenModeration}
                            setOpenModerationStatus={setOpenModerationStatus}
                            contentModeration={p_.company.contentModeration}
                        />
                    }
                />
            )
        }

        if (p_.selectedItems.length) {
            return null
        }

        return (
            <div className={grid.mt_md}>
                <TagsList
                    title={translate('tags')}
                    tags={p_.tags}
                    onUpdate={updateSourceTag}
                    onDelete={deleteSourceTag}
                    onCreate={createSourceTag}
                    className={'test-content-tag'}
                />
            </div>
        )
    }

    const deleteFilesFolders = () => {
        let idFiles: number[] = []
        let idFolders: number[] = []

        p_.selectedItems.forEach((item: { id: number; isDirectory: number }) => {
            item.isDirectory ? idFolders.push(item.id) : idFiles.push(item.id)
        })

        const deletePromises = []

        if (idFolders.length > 0) {
            deletePromises.push(api.send('deleteFolder', { id: idFolders }))
        }

        if (idFiles.length > 0) {
            deletePromises.push(api.send('deleteFile', { id: idFiles }))
        }

        Promise.all(deletePromises).then(() => {
            p_.onChange([])
        })
    }

    const editFilesFolders = (data: Data) => {
        const { sourceId, folderId, newFolderId } = data
        const dataToEditFiles = omitEmpty({
            parentId: newFolderId,
            sourceId,
            sourceFolderId: folderId,
        })

        api.send('moveFilesAndFolders', dataToEditFiles).then(() => {
            p_.onChange([])
        })
    }

    const s_ = { currentIndexSlider, sliderItems, isOpenedSmartFolderSettings }
    const sources = p_.selectedItems.filter((source: { isDirectory: number }) => !source.isDirectory)
    const query = getURLSearchParamsByLocation(p_.location)
    const folderId = query.folderId
    const isUploadable = helpers.isAvailable({ key: 'files', action: 'create' }) && folderId

    const renderTopContent = () => {
        return (
            <div className={filesStyles.sidebarWrapper}>
                <SidebarMultiselectMenu>
                    <MenuItem
                        data={{ name: 'move' }}
                        onClick={() => {
                            p_.onGetFoldersOnMultiple()
                            moveItemRef.current()
                        }}
                    />
                    <MenuItem
                        data={{ name: 'delete' }}
                        onClick={() => {
                            deleteItemRef.current()
                        }}
                    />
                    {p_.selectedItems &&
                        p_.selectedItems.length &&
                        p_.company?.contentModeration &&
                        helpers.isAvailable({ key: 'moderation', action: 'update' }) && (
                            <div
                                className={filesStyles.menuItem}
                                onClick={() => {
                                    setOpenModeration(true)
                                }}
                            >
                                {translate('moderation')}
                            </div>
                        )}
                    <div
                        className={filesStyles.menuItem}
                        onClick={function () {
                            if (p_.openTagsEditModalOpen) {
                                p_.openTagsEditModalOpen()
                            }
                        }}
                    >
                        {translate('tags')}
                    </div>
                </SidebarMultiselectMenu>
            </div>
        )
    }

    return (
        <React.Fragment>
            <Sidebar
                onSelectInfo={p_.onSelectInfo}
                selectSidebar={(selectedSide: string) => p_.setToolbar(selectedSide)}
                selectedSide={isUploadable ? p_.toolbar : 'right'}
                onGetFoldersOnMultiple={p_.onGetFoldersOnMultiple}
                content={{
                    right:
                        !p_.selectedInfo && p_.selectedItems.length
                            ? {
                                  title: `${translate('countOfSelectedContents')} ${
                                      p_.selectedItems ? p_.selectedItems.length : ''
                                  }`,
                                  options: p_.selectedItems,
                                  folders: p_.folders,
                                  folderId: folderId,
                                  editTitle: translate('parentFolder'),
                                  isDirectory: (option: { isDirectory: number }) => option.isDirectory,
                                  downloadLink: p_.downloadLink,
                              }
                            : null,
                }}
                topContent={{
                    right: p_.selectedItems.length ? renderTopContent() : null,
                }}
                bottomContent={{
                    right: !p_.selectedItems.length ? (
                        <BottomContent
                            downloadLink={
                                p_.selectedItems.length && checkTextItems(p_.selectedItems) ? null : p_.downloadLink
                            }
                            openTagsEditModalOpen={p_.openTagsEditModalOpen}
                            showPreview={false}
                            onChange={p_.onChange}
                            onEdit={p_.onEdit}
                            contentModeration={p_.company?.contentModeration}
                            setOpenModeration={setOpenModeration}
                            setOpenModerationStatus={setOpenModerationStatus}
                        />
                    ) : null,
                }}
                customContent={{
                    left: isUploadable ? (
                        <ToolbarUploads
                            uploads={p_.uploads}
                            folderId={folderId}
                            cancelUploadByUrl={cancelUploadByUrl}
                            cancelUpload={p_.cancelUpload}
                        />
                    ) : null,
                    right: getCustomRightContent(),
                }}
                onChange={(list: {}[], side?: string) => {
                    if (side === 'right') {
                        p_.onChange(list)
                    }
                }}
                onSubmit={(side: string, type: string, data: Data) => {
                    if (side === 'right' && type === 'delete') {
                        deleteFilesFolders()
                    } else if (side === 'right' && type === 'edit') {
                        editFilesFolders(data)
                    }
                }}
                icon={{
                    left: {
                        name: 'download',
                    },
                }}
                isEmpty={{
                    right: false,
                }}
                emptyText={{
                    right: {
                        title: translate('elementNotSelected'),
                        description: translate('fileNotSelectedDescription'),
                    },
                }}
                isShowActions={false}
                isEditable={!helpers.isSomeNotHaveAction(p_.selectedItems, 'update')}
                isDeletable={!helpers.isSomeNotHaveAction(p_.selectedItems, 'delete')}
                moveItemRef={moveItemRef}
                deleteItemRef={deleteItemRef}
            />
            <FilesEditTagsModal sources={sources} tags={p_.tags} />
            {s_.isOpenedSmartFolderSettings && (
                <SmartFolderSettings
                    onClose={onCloseSmartFolderSettings}
                    smartFolderRules={p_.selectedInfo.smartFolderRules}
                    folderId={p_.selectedInfo.id}
                />
            )}
            <ModalWithBackground
                isOpen={isOpenModeration}
                onClose={() => setOpenModeration(false)}
                title={translate('contentModerationTitle')}
            >
                <FilesModeration
                    selectedInfo={p_.selectedInfo}
                    onClose={() => setOpenModeration(false)}
                    selectedItems={p_.selectedItems}
                />
            </ModalWithBackground>
            <ModalWithBackground
                isOpen={isOpenModerationStatus}
                onClose={() => setOpenModerationStatus(false)}
                title={translate('moderationStatus')}
                showCloseIcon={true}
            >
                <FilesModerationStatus selectedInfo={p_.selectedInfo} onClose={() => setOpenModerationStatus(false)} />
            </ModalWithBackground>
        </React.Fragment>
    )
}

const mapStateToProps = (state: any) => ({
    toolbar: state.files.toolbar,
    uploads: state.downloads.uploads,
    folders: state.files.folders,
    displayedTooltips: state.user.data.settings.displayedTooltips,
    settings: state.user.data.settings,
    company: state.user.company,
    isPreviewOpen: state.files.isPreviewOpen,
    tags: state.files.tags,
    files: state.files.files,
})

const mapDispatchToProps = (dispatch: any) => {
    return {
        openTagsEditModalOpen: () => dispatch(filesActions.openTagsEditModalOpen()),
        openPreview: () => dispatch(filesActions.openPreview()),
        rotateVideo: (video: { sourceId: number }) => dispatch(rotateVideo(video)),
        setToolbar: (toolbar: any) => dispatch(filesActions.setToolbar(toolbar)),
        cancelUpload: (id: string) => dispatch(cancelUpload(id)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FilesToolbar))
